import { useState, useCallback } from "react";

const DEFAULT_CONFIG = {
  exclude_date_ranges: [],
  exclude_weekends: false,
};

// API calls disabled - using local state only until backend is updated
export const useActionsConfig = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error] = useState(null);

  const fetchConfig = useCallback(() => {
    // No-op: API disabled
  }, []);

  const updateConfig = useCallback(async (newConfig) => {
    setSaving(true);
    setConfig((prev) => ({ ...prev, ...newConfig }));
    setSaving(false);
    return newConfig;
  }, []);

  return {
    config,
    setConfig,
    loading,
    saving,
    error,
    updateConfig,
    refetch: fetchConfig,
  };
};
